let _prettify;
export function setPrettify(instance) {
    _prettify = instance;
}
export function getPrettify() {
    return _prettify;
}
